export const CONTAINER = {
  display: 'flex',
  flexFlow: 'column',
  height: '100%',
};

export const HEADER = {
  flex: '0 1 auto',
};

export const BODY = {
  flex: '1 1 auto',
};

export const FOOTER = {
  flex: '0 1 40px',
};

export const CONTENT = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  // backgroundColor: '#ffcc33',
  overflow: 'hidden',
};

export const CONTENTSUBARU = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  // backgroundColor: '#ffcc33',
  overflow: 'hidden',
};

export const IMAGE = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  borderRadius: '4px',
};

export const IMAGESUBARU = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '100%',
  height: 'auto',
  borderRadius: '4px',
  transform: 'translate(-50%, -50%)',
};

export const ROW = {
  display: 'flex',
  flexDirection: 'row',
}
